import React from 'react'
import { ReduxFormFieldWrapper } from '@adc/ui-core'
import _ from 'lodash'
import classNames from 'classnames/bind'
import { InvestorPreferences } from '../../../../util'
import Search from '../../../search'
import LocationPills from './locationPills'
import cls from './styles.scss'
const cx = classNames.bind(cls)

const QUESTION_SETS = InvestorPreferences.IP_OBJECT()
const LOOKING_TO_BUY_QUESTION =
  InvestorPreferences.IP_QUESTION_CODE.INV_ONBOARDING_LOOKING_TO_BUY

export default ReduxFormFieldWrapper(fieldProps => {
  const {
    value,
    className,
    onChange,
    touched,
    error,
    elmId,
    label = QUESTION_SETS[LOOKING_TO_BUY_QUESTION].label,
  } = fieldProps

  const hasLocationPills = _.isArray(value) && value.length > 0
  const disabled = _.isArray(value) && value.length === 5
  const showError = touched && !!error
  const removeValue = data => () => {
    onChange(_.filter(value, v => v !== data))
  }

  const onSearchSubmit = async suggestion => {
    await onChange(
      InvestorPreferences.updateValueBasedOnSuggestion(value, suggestion)
    )
  }

  return (
    <div className={className}>
      <span className={cx('input-label')}>{label}</span>
      <div
        className={cx(
          'search-input',
          showError && 'error',
          disabled && 'disabled'
        )}
      >
        <Search
          disabled={disabled}
          elmId={`${elmId}_onboarding`}
          label='Where I want to buy: (maximum of 5)'
          placeholder='County, City, ZIP'
          onSearchSubmit={onSearchSubmit}
          clearInputOnSearch
          includedSuggestionTypes={['county', 'city', 'zip', 'currentLocation']}
          categorizeResults
        />
        {hasLocationPills && (
          <LocationPills
            value={_.isArray(value) ? value : []}
            removeValue={removeValue}
          />
        )}
      </div>
      {showError && <div className={cx('error-text', 'u-mb-1')}>{error}</div>}
    </div>
  )
})
